(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rxjs"));
	else if(typeof define === 'function' && define.amd)
		define(["rxjs"], factory);
	else if(typeof exports === 'object')
		exports["ocJs"] = factory(require("rxjs"));
	else
		root["ocJs"] = factory(root["rxjs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 